const endpoints = {
  generateVoice: '/api/v1/text-to-speech/generate-voice',
  getAllVoices: '/api/v1/text-to-speech/get-all-voices',
};
export default endpoints;
